import React from 'react';
import {
	Table,
	message,
	Popconfirm,
	Button,
	Icon,
	Input,
	Select,
	Form,
	Modal,
	Row,
	Col,
	Tooltip,
	Tag,
	Badge,
	Statistic,
	Pagination,
	Avatar
} from 'antd';
import {orderPendingAc} from '../../../redux/actions';
import {connect} from 'react-redux';
import moment from 'moment';
import ModalRender from './ModalRender';
import ModalUpload from './ModalUpload';
import {server} from '../../../config/serverConfig';
import OrderDetail from '../../../components/orderDetail';



function RenderBase({appRd,store,del,set, pushsub,get, push,create, update,updateremove }) {


		//导入本组件所需参数变量
		const {data, dataLoading, dataFetchProps, selectedRows, selectedRowKeys, modalVisible, modalType, uploadModalVisible, selectedRow, selectedRowIndex,orderDetailVisible,clickRow,pagination} = store;
		const {screenType,loginUserRoleAuth} =appRd;	
		
		
		
		//刷新按钮强制刷新，需要提示
		const refreshData =async ()=>{
			let msg =await get(dataFetchProps);
			message.info(msg);
		}	
		
		//加载刷新，不需要提示前台
		if(dataLoading){ 			
			get(dataFetchProps);			
		}   // {onlyDeletedRows: true,user_name: 'a', roleid: 'admin', order:[['id']], offset: 2, limit: 2}		
			
		
		//定义表头
		const columns = [{
		  title: 'id',
		  dataIndex: 'id',
		  key: 'id',
		  className: 'align_center',
			width: 80,
		},{
			title: '产品模式',
			dataIndex: 'guarantee_type',
			key: 'guarantee_type',
			width: 120,
			render: (text, record) => (
				<div>
					{text !== undefined && text !== null ? (
						<span>
          <Avatar size="small" style={{ marginRight: 8 }}>
            {text === 0 ? '企' : text === 1 ? '大' : ''}
          </Avatar>
          <span style={{ fontSize: '14px', fontWeight: 'normal', color: text === 0 ? '#1890ff' : text === 1 ? '#00bcd4' : 'inherit' }}>
            {text === 0 ? '企信宝' : text === 1 ? '大经宝' : ''}
          </span>
        </span>
					) : (
						''
					)}
				</div>
			),
		},{
		  title: '客户名称',
		  dataIndex: 'm_orderclient',
		  key: 'm_orderclient',
		   render:(text,record)=>text.length>0 && text[0].cust_name ?<span>{text[0].cust_name}</span>:<span>{record.client_id}</span>,
		}
		,{
		  title: '订单编号',
		  dataIndex: 'order_no',
		  key: 'order_no'	,
		  render:(text,record)=>record.is_order_sub ? <Tooltip placement="topLeft" title='补充订单'><Tag color="#2E8B57">{text}</Tag> </Tooltip>:<span>{text}</span>
			
		  
		},
			{
				title: '贷款期限(天)',
				dataIndex: 'loan_term',
				key: 'loan_term',
				width: 90,
				render: (text) => <span style={{ color: '#00BFFF' }}>{text}</span>  // 天蓝色
			},{
		  title: '接收时间',
		  dataIndex: 'created_at',
		  key: 'created_at',	
		  render:(text,record) =>moment(record.created_at).format('YYYY-MM-DD'),
		},{
		  title: '订单',		 
		  key: 'orderDetail',			 
		  render:(text,record)=>{
			  
				if (text){					
					return <Button onClick={()=>BtnShowOrderDetail(record)}>查看</Button>
				}
				return <span>未上传</span>
				
			}	
		},{
		  title: '支付金额',
		  dataIndex: 'pay_amount',
		  key: 'pay_amount', render:text=><Statistic value={text/100} precision={2} valueStyle ={{fontSize:'15px',fontWeight:'bold'}}/>		 
		},{
		  title: '子公司',
		  dataIndex: 'company',
		  key: 'company',		 
		},{
		  title: '分公司',
		  dataIndex: 'subcompany',
		  key: 'subcompany',		 
		},	{
				title: '业务员',
				dataIndex: 'bizperson',
				key: 'bizperson',
				render: (text) => (
					<div>
						{text ? (
							<span>
               <Avatar size="small" style={{ marginRight: 8, backgroundColor: '#69c0ff', color: '#fff' }}>
  {text.charAt(0)}
</Avatar>
              <Statistic value={text} valueStyle={{ fontSize: '15px', fontWeight: 'bold' }} />
            </span>
						) : (
							''
						)}
					</div>
				),
				width: 80,
			},{
		  title: '业务合同',
		  dataIndex: 'contract_local_url',
		  key: 'contract_local_url',	
			render:(text)=>{
				if (text){
					let hrefStr =server.path + text;
					return <a href ={hrefStr} target='_blank'>查看</a>
				}
				return <span>未上传</span>
				
			}
		},
		];	
		
		//定义移动界面表头
		const mobileColumns = [{
		  title: '待审批订单列表',
		  dataIndex: 'm_orderclient',
		  key: 'm_orderclient',	
			render:(text,record)=>{
				let hrefStr =server.path + record.contract_local_url;
				return (
				<span>
					<Row><Col><Tag color="#108ee9">{text.length>0 && text[0].cust_name ?<span>{text[0].cust_name}</span>:<span>客户ID:{record.client_id}</span>}</Tag></Col> 
					
					<Col>订单号:{record.order_no}</Col> 
					<Col>接收时间:{ record.created_at && moment(record.created_at).format('YYYY-MM-DD HH:mm')}</Col> 
					<Col><Statistic value={record.pay_amount/100} precision={2} valueStyle ={{fontSize:'15px',fontWeight:'bold'}}/></Col>
					</Row>
					<Row><Col>{record.subcompany}-{record.bizperson}</Col>
					</Row>
					{record.contract_local_url && <a href ={hrefStr} target='_blank'>业务合同</a> }					
					<Button size='small' onClick={()=>BtnShowOrderDetail(record)}>订单详情</Button>
				
				
				</span>
			)}		  
		}];	
		
		
		const rowSelection = {
			selectedRowKeys,
			selectedRows,
			onSelect: (record, selected, selectedRows, nativeEvent)=>{
				if(selected){set({selectedRowKeys: [record.id], selectedRow: record, selectedRows: [record]})
					} else {set({selectedRowKeys: [], selectedRow: {}, selectedRows: []})}
				},
		    //onChange: (selectedRowKeys, selectedRows) => { SET({selectedRowKeys, selectedRows}) }
		};
		
		const BtnDelete =()=>{
			return del({id:selectedRow.id, selectedRowIndex}).then(res=>{
				message.info('id:' + selectedRow.id +' 的记录' + res)
				set({selectedRow:{}, selectedRowIndex: -1})
				});						
		}	 

		const BtnHandle=(e)=>{
			if (e.target.name ==='update'){		
				
				let company =selectedRow.m_orderclientForCompany[0];				
				if (!company || !company.bank_royalty_register ){
					message.error('子公司不存在或未登记为分账公司');
					return;
				}
				
				
				set({modalVisible:true, modalType: 'update'}); 		  
			}	
			if (e.target.name ==='create'){
				set({modalVisible:true, modalType: 'create'}); 	  			
			}	
			
			if (e.target.name==='upload'){
				set({uploadModalVisible:true}); 		  
			}
		} 	

		const BtnShowOrderDetail = (record)=>{		  
		   set({orderDetailVisible:true,clickRow:record})		  
		  }		

		const orderDetailProps = {	
			item:clickRow,
			visible: orderDetailVisible,
			onOk (data) {				
			  console.log('onOk');
			  set({orderDetailVisible:false})	
			}, 
				
			onCancel () {
			  set({orderDetailVisible:false})		  
			},
		  }		  
		pagination.onChange =(page, pageSize)=>{	
			if (isNaN(pageSize) ){
				//这是异常刷新，不记录任何值,比如排序刷新
				return;
			}			
			let paginationNew ={...pagination};
			paginationNew.current=page;  //如果page是1，直接提交即可			
			paginationNew.pageSize =pageSize;			
			set({pagination:paginationNew,dataLoading:true});
			
		}
		
		pagination.onShowSizeChange =(current, size)=>{
			let paginationNew ={...pagination};
			let overcount =paginationNew.pageSize * (paginationNew.current-1);	
			
			paginationNew.current  =1 + parseInt(overcount/size);
		
			paginationNew.pageSize =size;				
			set({pagination:paginationNew,dataLoading:true});
				
		}	
		
		const tableDefinition = {
			rowKey: 'id',
			loading: dataLoading,
			pagination:pagination,
			size: 'small',
			columns: screenType =='pc'? columns:mobileColumns,
			dataSource: data,
			//expandedRowRender: record => <p style={{ margin: 0}}>{JSON.stringify(record,['user_id','mobile','email','roleid','groupid','subgroup','mail_user_rule','mail_grp_rule'])}</p>,
			//rowSelection: rowSelection,
			onRow: (record, index) => { return { onClick: event => set({selectedRow:record, selectedRowIndex: index})}},
			rowClassName: (record, index) => index === selectedRowIndex ? 'selectedItem' : '',
			scroll:{x:800, y: window.innerHeight-370},
		}

	  const modalRenderProps = {
		
		item: modalType === 'create' ? {} : selectedRow,
		type: modalType,
		visible: modalVisible,
		onOk (data) {	
		  
			let Id = data.id;
			// 提交后台记录状态更新审批记录
					
			updateremove(data, selectedRowIndex).then((res)=> { message.info(res) });
			
			//提交补充差订单
			if (data.is_order_sub){			  
			  
			  //  pushOrderSub
			   pushsub({id:Id}).then((res)=> { message.info(res) }); 
							
				
			}else{
				//提交业务订单
						
				push({id:Id}).then((res)=> { message.info(res) }); 
				
				
			}
			
			set({modalVisible:false})	;  	  
			
			 
		  
		}, 

		onReject (data) {				
		  set({modalVisible:false})				
		  updateremove(data, selectedRowIndex).then(res=> message.info(res));   //更新请求					
		 
		}, 		
		onCancel () {
		  set({modalVisible:false})		  
		},
	  }
	  
	  const modaluploadProps = {
		
		item: selectedRow,		
		visible: uploadModalVisible,
		onOk (data) {
			
		  set({uploadModalVisible:false})
		  
		  update(data, selectedRowIndex).then(res=> message.info(res)); 	
		},  
		onReject(data) {
			
		  set({uploadModalVisible:false})
		  
		  update(data, selectedRowIndex).then(res=> message.info(res)); 	
		}, 		
		onCancel () {
		  set({uploadModalVisible:false})
		},
	  }
	 
		const ModalRenderGene = () => <ModalRender {...modalRenderProps}/>; 	 
		const ModaluploadGene = () => <ModalUpload {...modaluploadProps}/>; 
		const ModalOrderDeatailGene = () => <OrderDetail {...orderDetailProps}/>; 
		
		return (
		<div>
			<Row style={{ marginBottom: 10 }}>
			<Col span={24}><Input.Group compact size="large">  
					  <Button onClick={refreshData}  > <Icon type="sync" style={{color:'green'}} />刷新</Button>	
					  <Button onClick={BtnHandle} name='upload' disabled={selectedRowIndex===-1} hidden={loginUserRoleAuth.indexOf('/order/pending/btn001')==-1} > <Icon type="upload" />上传合同</Button>
					   <Button onClick={BtnHandle} name='update' disabled={selectedRowIndex===-1} hidden={loginUserRoleAuth.indexOf('/order/pending/btn002')==-1}> <Icon type="edit" />审核订单</Button>
						
													
				</Input.Group>
				</Col>

			</Row>		
		   <Table {...tableDefinition}/>
			{modalVisible&&<ModalRenderGene/>}
			{uploadModalVisible&&<ModaluploadGene/>}
			{orderDetailVisible&&<ModalOrderDeatailGene/>}
		</div>);
  

}

const mapStateToProps = (state) => {
  return {
    store: state.orderPendingRd ,
	appRd: state.appReducer 		
	}
}

const mapDispatchToProps = (dispatch,ownProps) => {
  return {  	
	set: (value)=>dispatch(orderPendingAc.SET(value)),
	get: (value)=>dispatch(orderPendingAc.GET(value)),
	update: (value,index)=>dispatch(orderPendingAc.UPDATE(value,index)),	
	updateremove: (value,index)=>dispatch(orderPendingAc.UPDATEREMOVE(value,index)),
	push: (value)=>dispatch(orderPendingAc.PUSH(value)),
	pushsub: (value)=>dispatch(orderPendingAc.PUSHSUB(value))
	}
}

const OrderPending =connect(mapStateToProps,mapDispatchToProps)(RenderBase);

export default OrderPending;
